import Head from "next/head";
import { FC } from "react";

import { HreflangAlternate } from "components/MetaTags";

export type BlogHreflangServiceProps = {
    hreflangs: HreflangAlternate[];
};

export const BlogHreflangService: FC<BlogHreflangServiceProps> = ({
    hreflangs,
}) => {
    return (
        <Head>
            {hreflangs.map(({ href, hrefLang }: HreflangAlternate) => (
                <link
                    href={href}
                    hrefLang={hrefLang}
                    rel="alternate"
                    key={href}
                />
            ))}
        </Head>
    );
};
